<template>
  <power-bi code="eyJrIjoiYjZlM2QyMDUtNjA5Ny00YzUxLWIwNmYtZWM5MjNjOTI3NzA2IiwidCI6ImM4NDJjMWQ5LWQzNjQtNDcxNi1iN2UzLWNhNDgxYTIzZDZhYyJ9" />
</template>

<script>
import PowerBi from '../components/PowerBi.vue';

export default {
    components: {
        PowerBi,
    },
};
</script>
